import React, { createContext, useEffect, useState } from 'react';
import jwtDecode from 'jwt-decode';
import { useDispatch } from 'react-redux';
import { getProfileByuserId } from 'redux/features/ProfileSlice';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isAuthReady, setIsAuthReady] = useState(false);
  const [refreshAuth, setRefreshAuth] = useState(0);

  const checkAuth = () => {
    const token = localStorage.getItem('token');

    try {
      if (!token) throw new Error('No token');
      let decoded = jwtDecode(token);
      if(!decoded?.data) {
        decoded = {
          data: decoded
        };
      }
      const isExpired = decoded?.data.exp < Date.now() / 1000;
      const hasUserId = !!decoded?.data.id;
      const hasUsername = !!decoded?.data.username;

      // console.log('TOKEN:', token);
      // console.log('DECODED:', decoded?.data, isExpired, hasUserId, hasUsername);

      if (!isExpired && hasUserId && hasUsername) {
        setIsLoggedIn(true);
        dispatch(
          getProfileByuserId(decoded?.data.id)
        )
      } else {
        setIsLoggedIn(false);
      }
    } catch (err) {
      console.log('Token validation failed:', err);
      setIsLoggedIn(false);
    }

    setIsAuthReady(true);
  };

  useEffect(() => {
    checkAuth();
  }, [dispatch, refreshAuth]);

  const recheckAuth = () => {
    setIsAuthReady(false);
    setRefreshAuth((prev) => prev + 1);
  };

  return (
    <AuthContext.Provider value={{ isLoggedIn, isAuthReady, recheckAuth }}>
      {children}
    </AuthContext.Provider>
  );
};
